import { useIntl } from "react-intl";

const BYOK = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.byok.title",
            defaultMessage: "BYOK encryption"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.byok.body",
            defaultMessage:
                "Encrypt Confluence data with a key you manage in your own instance of AWS KMS."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default BYOK;
